/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StocktakeReports
 */
angular.module('mercury.modules.stock.stocktakereport')
.factory('StocktakeReports', ["$http", "$q", "settings", function($http, $q, settings) {

  /**
   * Run the stocktake report for 2 given stocktakes
   *
   * @memberof StocktakeReports
   * @param  {String} startStocktakeId Id of the opening stocktake
   * @param  {String} endStocktakeId   Id of the closing stocktake
   */
  function stocktakeReport(startStocktakeId, endStocktakeId) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: settings.mercHost + '/stock/stocktakereport/generate',
      params: {startStocktake: startStocktakeId, endStocktake: endStocktakeId}
    })
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * Get the calculated usage for a given item between a period
   *
   * @memberof StocktakeReports
   * @param  {String} itemId    Id of stock item to get usage for
   * @param  {String} startTime start of period
   * @param  {String} endTime   end of period
   */
  function calculatedUsage(itemId, startTime, endTime) {
    var deferred = $q.defer();

    $http({
      method: 'get',
      url: settings.mercHost + '/stock/stocktakereport/calculatedusage',
      params: {itemId: itemId, startTime: startTime, endTime: endTime}
    })
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  return {
    stocktakeReport: stocktakeReport,
    calculatedUsage: calculatedUsage
  };
}]);
